import React from "react";

const AnalyticsPage = (props) => {
	return <div>{props.children}</div>;
};

export default AnalyticsPage;
